import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-background/80 backdrop-blur-md border-b border-border py-3' : 'bg-transparent py-5'}`} data-id="element-89">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-90">
        <div className="flex justify-between items-center" data-id="element-91">
          {/* Logo */}
          <div className="flex items-center gap-3" data-id="element-92">
            <span className="font-heading text-3xl text-accent-yellow tracking-wider" data-id="element-93">
              SSS
            </span>
            <span className="hidden sm:block text-muted text-sm font-medium tracking-wide border-l border-border pl-3" data-id="element-94">
              SOCIAL SURVIVAL SCRIPT
            </span>
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:block" data-id="element-95">
            <button onClick={() => document.getElementById('final-cta')?.scrollIntoView({
            behavior: 'smooth'
          })} className="bg-accent-orange hover:bg-orange-600 text-white font-bold py-2 px-6 rounded-full transition-colors duration-200 text-sm tracking-wide shadow-lg shadow-orange-900/20" data-id="element-96">
              GET INSTANT ACCESS →
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-97">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-primary p-2" data-id="element-98">
              {isMobileMenuOpen ? <X size={24} data-id="element-99" /> : <Menu size={24} data-id="element-100" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-surface border-b border-border p-4 animate-in slide-in-from-top-5" data-id="element-101">
          <div className="flex flex-col gap-4" data-id="element-102">
            <span className="text-muted text-sm font-medium text-center" data-id="element-103">
              SOCIAL SURVIVAL SCRIPT
            </span>
            <button className="w-full bg-accent-orange hover:bg-orange-600 text-white font-bold py-3 px-6 rounded-lg transition-colors duration-200 text-sm tracking-wide" data-id="element-104">
              GET INSTANT ACCESS →
            </button>
          </div>
        </div>}
    </nav>;
}